import React from "react";
import { Box, Slider, SliderProps, FormControl, FormHelperText } from '@mui/material';
import { useField } from "formik";
import { ValidationMessages } from "./index";

export interface SliderFormikProps
  extends Omit<SliderProps, "name" | "onChange" | "onBlur" | "error"> {
  name: string;
  status?: boolean;
}

const SliderFormik = ({ name, status, ...props }: SliderFormikProps) => {
  const [field, meta, fieldHelpers] = useField(name);

  return (
    <Box pt={3}>
      <FormControl fullWidth error={meta.touched && Boolean(meta.error)}>
        <Slider
          valueLabelDisplay="on"
          name={field.name}
          id={field.name}
          value={field.value || 0}
          disabled={status}
          onChange={(event, value) => fieldHelpers.setValue(value)}
          {...props}
        />
        <ValidationMessages meta={meta} />
      </FormControl>
    </Box>
  );
};

export default SliderFormik;
